import React from 'react';
import Navbar from './Navbar';

function TermsAndConditions() {
  return (
    <div className="pt-5">
      <Navbar />
      <div className="px-5 ml-0 mt-5" style={{ background: '#fff', lineHeight: '2' }}>
        <p className="profile__label mb-3 ml-0" style={{ fontSize: '30px', color: 'black' }}>
          Terms of Service
        </p>
        <div className="form-group">
          <label className="mb-0 d-block">Introduction</label>
          <p style={{ color: 'var(--gray)' }}>
            This is a legal agreement between you, the potential user of this website ("you"), and Ayata Inc. Your use
            of Ayata Inc.'s products, services and web sites, this website, or any of the products and services offered
            on this Site is conditioned on your acceptance, without modification, of these Terms of Service. Please read
            these Terms carefully. If you do not agree to these Terms, you should not use the Services. You accept the
            Terms by using the Ayata Inc. Services in any way. In this case, you understand and agree that Ayata Inc.
            will consider your use of the Services as agreement to the Terms. The Terms include the provisions in this
            document, as well as those in the Privacy Policy and any additional terms that you agree to.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            Ayata Inc. may, at its sole discretion, modify these Terms at any time, but if we do, we will bring it to
            your attention by placing a notice on the Site, by sending you an email, and/or by some other means. If you
            donít agree with the new Terms, you are free to reject them; unfortunately, that means you will no longer be
            able to use the Services. If you use the Services in any way after a change to the Terms is effective, that
            means you agree to all of the changes.
          </p>
          <p className="font-weight-bold" style={{ color: 'var(--gray)' }}>
            NOTICE: Please read these Terms carefully. They cover important information about Services provided to you
            and any charges, taxes, and fees we bill you. These Terms include information about automatic renewals,
            limitations of liability, a class action waiver, and resolution of disputes by arbitration instead of in
            court.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            ARBITRATION NOTICE AND CLASS ACTION WAIVER: EXCEPT FOR CERTAIN TYPES OF DISPUTES DESCRIBED IN THE
            ARBITRATION SECTION BELOW, YOU AGREE THAT DISPUTES BETWEEN YOU AND Ayata Inc. WILL BE RESOLVED BY BINDING,
            INDIVIDUAL ARBITRATION AND YOU WAIVE YOUR RIGHT TO PARTICIPATE IN A CLASS ACTION LAWSUIT OR CLASS-WIDE
            ARBITRATION.
          </p>
        </div>
        <div className="form-group">
          <label className="mb-0 d-block">Provision Of Services</label>
          <p style={{ color: 'var(--gray)' }}>
            Ayata Inc. is constantly innovating in order to provide the best possible experience for its users. You
            acknowledge and agree that the form and nature of the Services, which Ayata Inc. provides, may change from
            time to time without prior notice to you.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            As part of this continuing innovation, you acknowledge and agree that Ayata Inc. may stop (permanently or
            temporarily) providing any of the Services to you or to users generally at Ayata Inc.'s sole discretion,
            without prior notice to you. You may stop using the Services at any time.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You acknowledge and agree that if Ayata Inc. disables access to your account, you may be prevented from
            accessing the Services, your account details, or any files or other content that is contained in your
            account.
          </p>
        </div>
        <div className="form-group">
          <label className="mb-0 d-block">Use Of The Services By You</label>
          <p style={{ color: 'var(--gray)' }}>
            In order to access certain Services, you may be required to sign up for an account, and select a password
            and user name. You promise to provide us with accurate, complete, and updated registration information about
            yourself. You may not select as your user name a name that you donít have the right to use, or another
            personís name with the intent to impersonate that person. You may not transfer your account to anyone else
            without our prior written permission.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You represent and warrant that you are an individual of legal age to form a binding contract (or if not,
            youíve received your parentís or guardianís permission to use the Services and gotten your parent or
            guardian to agree to these Terms on your behalf).
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You agree to use the Services only for purposes that are permitted by (a) the Terms and (b) any applicable
            law, regulation, or generally accepted practices or guidelines in the relevant jurisdictions (including any
            laws regarding the export of data or software to and from the Nepal, United States, United Kingdom, India,
            and other relevant countries). If your use of the Services is prohibited by applicable laws, then you arenít
            authorized to use the Services. We canít and wonít be responsible for your using the Services in a way that
            breaks the law.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You agree not to access (or attempt to access) any of the Services by any means other than through the
            interface that is provided by Ayata Inc., unless you have been specifically allowed to do so in a separate
            agreement with Ayata Inc. You specifically agree not to access (or attempt to access) any of the Services
            through any automated means (including use of scripts or web crawlers) and shall ensure that you comply with
            the instructions set on the Services.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You agree that you will not engage in any activity that interferes with or disrupts the Services (or the
            servers and networks which are connected to the Services). Unless you have been specifically permitted to do
            so in a separate agreement with Ayata Inc., you agree that you will not reproduce, duplicate, copy, sell,
            trade, or resell the Services for any purpose.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You agree that you are solely responsible for (and that Ayata Inc. has no responsibility to you or to any
            third party for) any breach of your obligations under the Terms and for the consequences (including any loss
            or damage which Ayata Inc. may suffer) of any such breach.
          </p>
        </div>
        <div className="form-group">
          <label className="mb-0 d-block">Accounts, Passwords, And Security</label>
          <p style={{ color: 'var(--gray)' }}>
            You agree and understand that you are responsible for not automating account creation. You are also
            responsible for maintaining the confidentiality of passwords associated with any account you use to access
            the Services. Accordingly, you agree that you will be solely responsible to Ayata Inc. for all activities
            that occur under your account. Ayata Inc. is not responsible whatsoever for any actions taken under your
            account.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            If you become aware of any unauthorized use of your password or of your account, you agree to notify Ayata
            Inc. immediately at mail@Ayatanepal.com.np.
          </p>
        </div>
        <div className="form-group">
          <label className="mb-0 d-block">Content In The Services</label>
          <p style={{ color: 'var(--gray)' }}>
            You understand that all information (such as files, media, images, text) which you may have access to as
            part of, or through your use of, the Services is the sole responsibility of the source from which such
            content originated. All such information is referred to here as the "Content". Ayata Inc. does its best to
            give proper credit to the source from which the data was indexed. Ayata Inc.'s search engine lays no claim
            to the ownership of the content originated at these sites. If some Content is cached, it is done for the
            sole purpose of providing users with the best possible service. If you think that any Content is
            objectionable, please inform Ayata Inc. at your convenience.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            Ayata Inc. respects the intellectual property of others, and we ask our users to do the same. If you believe
            that your work is used in a way that constitutes copyright infringement, or your intellectual property
            rights have been otherwise violated, please send a notice of copyright infringement containing the following
            information to mail@Ayatanepal.com:
          </p>
          <p className="small ml-5 " style={{ color: 'var(--gray)' }}>
            <span className="d-block text-dark font-weight-bold">1.1</span>
            <p style={{ color: 'var(--gray)' }}>
              A signature (electronic or physical) of the person authorized to act on behalf of the owner of the
              copyright or other intellectual property interest that has been allegedly infringed.
            </p>
            <span className="d-block text-dark font-weight-bold">1.2</span>
            <p style={{ color: 'var(--gray)' }}>
              A description of the copyrighted work or other material being infringed.
            </p>
            <span className="d-block text-dark font-weight-bold">1.3</span>
            <p style={{ color: 'var(--gray)' }}>
              Identification of the material that is claimed to be infringing including information regarding the
              location of the infringing materials that the copyright owner seeks to have removed, with sufficient
              detail so that Ayata Inc. is capable of finding and verifying its existence; The notifierís address,
              telephone number, and email address.
            </p>
            <span className="d-block text-dark font-weight-bold">1.4</span>
            <p style={{ color: 'var(--gray)' }}>
              A statement that the notifier has a good faith belief that the material identified is not authorized by
              the copyright owner, its agent, or the law.
            </p>
            <span className="d-block text-dark font-weight-bold">1.5</span>
            <p style={{ color: 'var(--gray)' }}>
              A statement made under penalty of perjury that all the above information is accurate, and that the
              notifying party is authorized to act on the behalf of the copyright owner.
            </p>
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You agree that you are solely responsible for (and that Ayata Inc. has no responsibility to you or to any
            third party for) any Content that you create, transmit, or display while using the Services and for the
            consequences of your actions (including any loss or damage which Ayata Inc. may suffer) by doing so.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You understand that by using the Services you may be exposed to Content that you may find offensive,
            indecent, or objectionable and that, in this respect, you use the Services at your own risk.
          </p>
        </div>
        <div className="form-group">
          <label className="mb-0 d-block">Ayata Inc.'s And Your Proprietary Rights</label>
          <p style={{ color: 'var(--gray)' }}>
            Unless you have agreed otherwise in writing with Ayata Inc., nothing in the Terms gives you a right to use
            any of Ayata Inc.'s trade names, trademarks, service marks, logos, domain names, and other distinctive brand
            features. You agree that you shall not remove, obscure, or alter any proprietary rights notices (including
            copyright and trade mark notices), which may be affixed to or contained within the Services. Unless you have
            been expressly authorized to do so in writing by Ayata Inc., you agree that in using the Services, you will
            not use any trade mark, service mark, trade name, or logo of any company or organization in a way that is
            likely or intended to cause confusion about the owner or authorized user of such marks, names or logos.
          </p>
        </div>
        <div className="form-group">
          <label className="mb-0 d-block">Payment</label>
          <p style={{ color: 'var(--gray)' }}>
            The Services may be free or we may charge a fee for using the Services. If you are using a free version of
            the Services, we will notify you before any Services you are then using begin carrying a fee, and if you
            wish to continue using such Services, you must pay all applicable fees for such Services. Note that if you
            elect to receive text messages through the Services, data and message rates may apply. Any and all such
            charges, fees or costs are your sole responsibility. You should consult with your wireless carrier to
            determine what rates, charges, fees or costs may apply to your use of the Services.
          </p>
          <p className="small ml-5" style={{ color: 'var(--gray)' }}>
            <span className="d-block text-dark font-weight-bold ">2.1</span>
            <p style={{ color: 'var(--gray)' }}>
              <span className="d-bold font-weight-bold">Paid Services.</span>Certain of our Services may be subject to
              payments now or in the future (the ìPaid Servicesî). Please note that any payment terms presented to you
              in the process of using or signing up for a Paid Service are deemed part of these Terms.
            </p>
            <span className="d-block text-dark font-weight-bold">2.2</span>
            <p style={{ color: 'var(--gray)' }}>
              <span className="d-bold font-weight-bold">Billing</span>. We use a third-party payment processor to bill
              you through a payment account linked to your account on the Services for use of the Paid Services. The
              processing of payments will be subject to the terms, conditions and privacy policies of the Payment
              Processor in addition to these Terms. We are not responsible for error by the Payment Processor. By
              choosing to use Paid Services, you agree to pay us, through the Payment Processor, all charges at the
              prices then in effect for any use of such Paid Services in accordance with the applicable payment terms
              and you authorize us, through the Payment Processor, to charge your chosen payment provider. You agree to
              make payment using that selected Payment Method. We reserve the right to correct any errors or mistakes
              that the Payment Processor makes even if it has already requested or received paymInc.
            </p>
            <span className="d-block text-dark font-weight-bold">2.3</span>
            <p style={{ color: 'var(--gray)' }}>
              <span className="d-bold font-weight-bold">Payment Method.</span> The terms of your payment will be based
              on your Payment Method and may be determined by agreements between you and the financial institution,
              credit card issuer or other provider of your chosen Payment Method. If we, through the Payment Processor,
              do not receive payment from you, you agree to pay all amounts due on your Billing Account upon demand.
            </p>
            <span className="d-block text-dark font-weight-bold">2.4</span>
            <p style={{ color: 'var(--gray)' }}>
              <span className="d-bold font-weight-bold"> Recurring Billing.</span> Some of the Paid Services may consist
              of an initial period, for which there is a one-time charge, followed by recurring period charges as agreed
              to by you. By choosing a recurring payment plan, you acknowledge that such Services have an initial and
              recurring payment feature and you accept responsibility for all recurring charges prior to cancellation.
              We may submit periodic charges (e.g., monthly) without further authorization from you, until you provide
              prior notice (receipt of which is confirmed by us) that you have terminated this authorization or wish to
              change your payment method. Such notice will not affect charges submitted before we reasonably could act.
              To terminate your authorization or change your payment method, go to the account settings on Ayata
              Inc.(Avyas) as applicable.
            </p>
            <span className="d-block text-dark font-weight-bold">2.5</span>
            <p style={{ color: 'var(--gray)' }}>
              <span className="d-bold font-weight-bold"> Current Information Required.</span> You must provide current,
              complete and accurate information for your billing account. You must promptly update all information to
              keep your billing account current, complete and accurate (such as a change in billing address, credit card
              number or credit card expiration date), and you must promptly notify us or our payment processor if your
              payment method is cancelled (e.g., for loss or theft) or if you become aware of a potential breach of
              security, such as the unauthorized disclosure or use of your user name or password. Changes to such
              information can be made in your account settings. If you fail to provide any of the foregoing information,
              you agree that we may continue charging you for any use of paid services under your billing account unless
              you have terminated your paid services as set forth above.
            </p>
            <span className="d-block text-dark font-weight-bold">2.6</span>
            <p style={{ color: 'var(--gray)' }}>
              <span className="d-bold font-weight-bold">Change in Amount Authorized.</span> If the amount to be charged
              to your Billing Account varies from the amount you preauthorize (other than due to the imposition or
              change in the amount of state sales taxes), you have the right to receive, and we shall provide, notice of
              the amount to be charged and the date of the charge before the scheduled date of the transaction. Any
              agreement you have with your payment provider will govern your use of your Payment Method. You agree that
              we may accumulate charges incurred and submit them as one or more aggregate charges during or at the end
              of each billing cycle.
            </p>
            <span className="d-block text-dark font-weight-bold">2.7</span>
            <p style={{ color: 'var(--gray)' }}>
              <span className="d-bold font-weight-bold"> Auto-Renewal for Paid Services.</span> Unless you opt out of
              auto-renewal, which can be done through your account settings, any Paid Services you have signed up for
              will be automatically extended for successive renewal periods of the same duration as the subscription
              term originally selected, at the then-current non-promotional rate. To change or resign your Paid Services
              at any time, go to account settings. If you terminate a Paid Service, you may use your subscription until
              the end of your then-current term and your subscription will not be renewed after your then-current term
              expires. However, you won't be eligible for a prorated refund of any portion of the subscription fee paid
              for the then-current subscription period. If you do not want to continue to be charged on a recurring
              monthly basis, you must cancel the applicable Paid Service through your account settings or terminate your
              Company account before the end of the recurring term. Paid Services cannot be terminated before the end of
              the period for which you have already paid, and except as expressly provided in these terms, Ayata Inc.
              will not refund any fees that you have already paid.
            </p>
            <span className="d-block text-dark font-weight-bold">2.8</span>
            <p style={{ color: 'var(--gray)' }}>
              <span className="d-bold font-weight-bold"> Reaffirmation of Authorization.</span> Your non-termination or
              continued use of a Paid Service reaffirms that we are authorized to charge your Payment Method for that
              Paid Service. We may submit those charges for payment and you will be responsible for such charges. This
              does not waive our right to seek payment directly from you. Your charges may be payable in advance, in
              arrears, per usage, or as otherwise described when you initially selected to use the Paid Service.
            </p>
            <span className="d-block text-dark font-weight-bold">2.9</span>
            <p style={{ color: 'var(--gray)' }}>
              <span className="d-bold font-weight-bold"> Free Trials and Other Promotions.</span> Any free trial or
              other promotion that provides access to a Paid Service must be used within the specified time of the
              trial. You must stop using a Paid Service before the end of the trial period in order to avoid being
              charged for that Paid Service. If you cancel prior to the end of the trial period and are inadvertently
              charged for a Paid Service, please contact us at mail@Ayatanepal.com.
            </p>
          </p>
        </div>
        <div className="form-group">
          <label className="mb-0 d-block">Termination Of Relationship With Ayata Inc.</label>
          <p style={{ color: 'var(--gray)' }}>
            Ayata Inc. may, at any time, terminate its legal agreement with you, including termination of your account,
            if you breach any provision of the Terms, as per the sole discretion of Ayata Inc. Ayata Inc. holds the
            right to deny you Services without any express reason. Ayata Inc. may also terminate the relationship with
            you if Ayata Inc. is legally required to do so (e.g., when provision of Services provided by Ayata Inc. is,
            or becomes, unlawful); or if the partner(s) with whom Ayata Inc. offered the Services to you has terminated
            its relationship with Ayata Inc. or ceased to offer the Services to you; or the provision of the Services to
            you by Ayata Inc. is, in Ayata Inc.'s opinion, no longer commercially viable.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            Youíre free to stop using the Services at any time, by contacting us at mail@Ayatanepal.com; please refer to
            our Privacy Policy, as well as the licenses described herein, to understand how we treat information you
            provide to us after you have stopped using our Services. Account termination may result in destruction of
            any content associated with your account, so keep that in mind before you decide to terminate your account.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            Provisions that, by their nature, should survive termination of these Terms shall survive termination. By
            way of example, all of the following will survive termination: any obligation you have to pay us or
            indemnify us, any limitations on our liability, any terms regarding ownership or intellectual property
            rights, and terms regarding disputes between us, including without limitation the arbitration agreemInc.
          </p>
        </div>
        <div className="form-group">
          <label className="mb-0 d-block">Exclusion Of Warranties</label>
          <p style={{ color: 'var(--gray)' }}>
            You expressly understand and agree that your use of the services is at your sole risk and that the services
            are provided "as is" and "as available". In particular, Ayata Inc., its subsidiaries and affiliates, and its
            licensor or suppliers do not represent or warrant to you that:
          </p>

          <div className="ml-5" style={{ color: 'var(--gray)', padding: '10px' }}>
            <div className="d-flex align-items-center ">
              <span className="d-block font-weight-bold" style={{ marginRight: '8px' }}>
                3.1
              </span>
              <p className="small mb-0" style={{ color: 'var(--gray)' }}>
                Your use of the Services will meet your requirements.
              </p>
            </div>

            <div className="d-flex align-items-center">
              <span className="d-block d-block font-weight-bold" style={{ marginRight: '8px' }}>
                3.2
              </span>
              <p className="small mb-0" style={{ color: 'var(--gray)' }}>
                Your use of the Services will be uninterrupted, timely, secure, or free from error.
              </p>
            </div>

            <div className="d-flex align-items-center">
              <span className="d-block d-block font-weight-bold" style={{ marginRight: '8px' }}>
                3.3
              </span>
              <p className="small mb-0" style={{ color: 'var(--gray)' }}>
                Any information obtained by you as a result of your use of the Services will be accurate, reliable, or
                legal.
              </p>
            </div>

            <div className="d-flex align-items-center">
              <span className="d-block d-block font-weight-bold" style={{ marginRight: '8px' }}>
                3.4
              </span>
              <p className="small mb-0 " style={{ color: 'var(--gray)' }}>
                Defects in the operation or functionality of any software provided to you as part of the Services will
                be corrected.
              </p>
            </div>
          </div>

          <p style={{ color: 'var(--gray)' }}>
            Any material downloaded or otherwise obtained through the use of the Services is done at your own discretion
            and risk, and you will be solely responsible for any damage to your computer system or other device, or loss
            of data that results from the download of any such material.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            No advice or information, whether oral or written, obtained by you from Ayata Inc., or through or from the
            Services shall create any warranty not expressly stated in the terms.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            Ayata Inc. further expressly disclaims all warranties and conditions of any kind, whether express or
            implied, including, but not limited to, the implied warranties and conditions of merchantability, fitness
            for a particular purpose, and non-infringement.
          </p>
        </div>

        <div className="form-group">
          <label className="mb-0 d-block">Limitation Of Liability</label>
          <p style={{ color: 'var(--gray)' }}>
            To the fullest extent allowed by applicable law, Ayata Inc. (and its licensor or suppliers) are never liable
            for any direct, indirect, incidental, special, consequential, or exemplary damages which may be incurred by
            you, however caused and under any theory of liability. This shall include, but not be limited to:
          </p>
          <p className="ml-5">
            <p style={{ color: 'var(--gray)' }}>
              Any loss of profit (whether incurred directly or indirectly), any loss of goodwill or business reputation,
              any loss of data suffered, cost of procurement of substitute goods or services, or other intangible loss;
            </p>
            <p style={{ color: 'var(--gray)' }}>
              Any loss or damage which may be incurred by you, including but not limited to loss or damage as a result
              of:
            </p>
            <p style={{ color: 'var(--gray)' }}>
              Any reliance placed by you on the completeness, accuracy or existence of any advertising, or as a result
              of any relationship or transaction between you and any advertiser or sponsor whose advertising appears on
              the services;{' '}
            </p>
            <p style={{ color: 'var(--gray)' }}>
              Any changes which Ayata Inc. may make to the services, or for any permanent or temporary cessation in the
              provision of the services (or any features within the services);
            </p>
            <p style={{ color: 'var(--gray)' }}>
              The deletion of, corruption of, or failure to store any content and other communications data maintained
              or transmitted by or through your use of the services.
            </p>
            <p style={{ color: 'var(--gray)' }}>
              Your failure to provide Ayata Inc. with accurate account information;
            </p>
            <p style={{ color: 'var(--gray)' }}>
              Your failure to keep your password or account details secure and confidential.
            </p>
          </p>

          <p style={{ color: 'var(--gray)' }}>
            The limitations on Ayata Inc.'s liability to you above shall apply whether or not Ayata Inc. has been
            advised of or should have been aware of the possibility of any such losses arising.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            To the fullest extent allowed by applicable law, under no circumstances and under no legal theory
            (including, without limitation, tort, contact, strict liability, or otherwise) shall Ayata Inc. (or its
            licensor or suppliers) be liable to you or to any other person for any amount, in the aggregate, in excess
            of the greater of (i) $100 or (ii) the amounts paid by you to Ayata Inc. in connection with the services in
            the twelve (12) month period preceding this applicable claim.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            Some states do not allow the exclusion or limitation of certain damages, so the above limitation and
            exclusions may not apply to you.
          </p>
        </div>
        <div className="form-group">
          <label className="mb-0 d-block">Indemnity</label>
          <p style={{ color: 'var(--gray)' }}>
            To the fullest extent allowed by applicable law, you agree to indemnify and hold Ayata Inc., its affiliates,
            officers, agents, employees, and partners harmless from and against any and all claims, liabilities, damages
            (actual and consequential), losses and expenses (including attorneys fees) arising from or in any way
            related to any third party claims relating to (a) your use of the Services (including any actions taken by a
            third party using your account), and (b) your violation of these Terms.
          </p>
        </div>
        <div className="form-group">
          <label className="mb-0 d-block">Advertisements</label>
          <p style={{ color: 'var(--gray)' }}>
            Some of the Services may be supported by advertising revenue and may display advertisements and promotions.
            These advertisements may be targeted to the content of information stored on the Services, queries made
            through the Services, or other information.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            The manner, mode, and extent of advertising by Ayata Inc. on the Services are subject to change without
            specific notice to you. In consideration for Ayata Inc. granting you access to and use of the Services, you
            agree that Ayata Inc. may place such advertising on the Services.
          </p>
        </div>
        <div className="form-group">
          <label className="mb-0 d-block">Application</label>
          <p style={{ color: 'var(--gray)' }}>
            These Terms apply to your use of all the Services, including the iOS applications available via the Apple,
            Inc. (ìAppleî) App Store (the ìApplicationî) and android applications available via Google, App store, but
            the following additional terms also apply to the Application:
          </p>

          <p className="small ml-4" style={{ color: 'var(--gray)' }}>
            <span className="d-block text-dark font-weight-bold">4.1</span>
            <p style={{ color: 'var(--gray)' }}>
              Both you and Ayata Inc. acknowledge that the Terms are concluded between you and Ayata Inc. only, and not
              with Apple or Google, and that Apple or Google are not responsible for the Application or the Content;
            </p>
            <span className="d-block text-dark font-weight-bold">4.2</span>
            <p style={{ color: 'var(--gray)' }}>
              The Application is licensed to you on a limited, non-exclusive, non-transferable, non-sub-licensable
              basis, solely to be used in connection with the Services for your private, personal, non-commercial use,
              subject to all the terms and conditions of these Terms as they are applicable to the Services;{' '}
            </p>
            <span className="d-block text-dark font-weight-bold">4.3</span>
            <p style={{ color: 'var(--gray)' }}>
              You will only use the Application in connection with an Apple or Android device that you own or control;
            </p>
            <span className="d-block text-dark font-weight-bold">4.4</span>
            <p style={{ color: 'var(--gray)' }}>
              You acknowledge and agree that Apple or Google has no obligation whatsoever to furnish any maintenance and
              support services with respect to the Application;
            </p>
            <span className="d-block text-dark font-weight-bold">4.5</span>
            <p style={{ color: 'var(--gray)' }}>
              In the event of any failure of the Application to conform to any applicable warranty, including those
              implied by law, you may notify Apple or Google of such failure; upon notification, Appleís or Google,s
              sole warranty obligation to you will be to refund to you the purchase price, if any, of the Application;
            </p>
            <span className="d-block text-dark font-weight-bold">4.6</span>
            <p style={{ color: 'var(--gray)' }}>
              You acknowledge and agree that Ayata Inc., and not Apple or Google, are responsible for addressing any
              claims you or any third party may have in relation to the Application;
            </p>
            <span className="d-block text-dark font-weight-bold">4.7</span>
            <p style={{ color: 'var(--gray)' }}>
              You acknowledge and agree that, in the event of any third party claim that the Application or your
              possession and use of the Application infringes that third partyís intellectual property rights, Ayata
              Inc., and not Apple or Google, will be responsible for the investigation, defense, settlement and
              discharge of any such infringement claim;
            </p>
            <span className="d-block text-dark font-weight-bold">4.8</span>
            <p style={{ color: 'var(--gray)' }}>
              Both you and Ayata Inc. acknowledge and agree that, in your use of the Application, you will comply with
              any applicable third party terms of agreement which may affect or be affected by such use; and
            </p>
            <span className="d-block text-dark font-weight-bold">4.9</span>
            <p style={{ color: 'var(--gray)' }}>
              Both you and Ayata Inc. acknowledge and agree that Apple and Appleís subsidiaries and Google and Google's
              subsidiaries are third party beneficiaries of these Terms, and that upon your acceptance of these Terms,
              Apple and Google will have the right (and will be deemed to have accepted the right) to enforce these
              Terms against you as the third party beneficiary hereof.
            </p>
          </p>
        </div>
        <div className="form-group">
          <label className="mb-0 d-block">Other Content</label>
          <p style={{ color: 'var(--gray)' }}>
            The Services may include hyper-links to other web sites or content or resources. Ayata Inc. may have no
            control over any web sites or resources which are provided by companies or persons other than Ayata Inc..
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You acknowledge and agree that Ayata Inc. is not responsible for the availability of any such external sites
            or resources, and does not endorse any advertising, products, or other materials on or available from such
            web sites or resources.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You acknowledge and agree that Ayata Inc. is not liable for any loss or damage which may be incurred by you
            as a result of the availability of those external sites or resources, or as a result of any reliance placed
            by you on the completeness, accuracy or existence of any advertising, products or other materials on, or
            available from, such web sites or resources.
          </p>
        </div>
        <div className="form-group">
          <label className="mb-0 d-block">Arbitration</label>
          <p style={{ color: 'var(--gray)' }}>
            <strong>
              Please read the following arbitration agreement carefully because it requires you to arbitrate certain
              disputes and claims with Ayata Inc. and limits the manner in which you can seek relief from us.
            </strong>{' '}
            Both you and Ayata Inc. acknowledge and agree that for the purposes of any dispute arising out of or
            relating to the subject matter of these Terms, Ayata Inc.ís officers, directors, employees and independent
            contractors (ìPersonnelî) are third party beneficiaries of these Terms, and that upon your acceptance of
            these Terms, Personnel will have the right (and will be deemed to have accepted the right) to enforce these
            Terms against you as the third party beneficiary hereof.
          </p>
          <p className="small ml-5" style={{ color: 'var(--gray)' }}>
            <span className="d-block text-dark font-weight-bold">5.1</span>
            <p style={{ color: 'var(--gray)' }}>
              <strong>Arbitration Rules. </strong>Applicability of Arbitration AgreemInc. Any dispute arising out of or
              relating to the subject matter of these Terms shall be finally settled by binding arbitration in
              Kathmandu, Nepal. The arbitration will proceed as per Arbitration Act 1999 A.D. of Nepal.
            </p>
            <span className="d-block text-dark font-weight-bold">5.2</span>
            <p style={{ color: 'var(--gray)' }}>
              <strong>Waiver of Jury Trial.</strong> You and Ayata Inc. waive any constitutional and statutory rights to
              go to court and have a trial in front of a judge or jury. You and Ayata Inc. are instead choosing to have
              claims and disputes resolved by arbitration. Arbitration procedures are typically more limited, more
              efficient, and less costly than rules applicable in court and are subject to very limited review by a
              court. In any litigation between you and Ayata Inc. over whether to vacate or enforce an arbitration
              award, you and Ayata Inc. waive all rights to a jury trial, and elect instead to have the dispute be
              resolved by a judge.
            </p>
            <span className="d-block text-dark font-weight-bold">5.3</span>
            <p style={{ color: 'var(--gray)' }}>
              <strong>Waiverof Class or Consolidated Actions.</strong> All claims and disputes within the scope of this
              arbitration agreement must be arbitrated or litigated on an individual basis and not on a class basis.
              Claims of more than one customer or user cannot be arbitrated or litigated jointly or consolidated with
              those of any other customer or user. If however, this waiver of class or consolidated actions is deemed
              invalid or unenforceable, neither you nor we are entitled to arbitration; instead all claims and disputes
              will be resolved in a court as set forth below.
            </p>
            <span className="d-block text-dark font-weight-bold">5.4</span>
            <p style={{ color: 'var(--gray)' }}>
              <strong>Opt-out</strong>. You have the right to opt out of the provisions of this Section by sending
              written notice of your decision to opt out. You must include (1) your name and residence address; (2) the
              email address and/or telephone number associated with your account; and (3) a clear statement that you
              want to opt out of these Terms arbitration agreement.
            </p>
            <span className="d-block text-dark font-weight-bold">5.5</span>
            <p style={{ color: 'var(--gray)' }}>
              <strong>Exclusive Venue.</strong> If you send the opt-out notice, and/or in any circumstances where the
              foregoing arbitration agreement permits either you or Ayata Inc. to litigate any dispute arising out of or
              relating to the subject matter of these Terms in court, then the foregoing arbitration agreement will not
              apply to either party and both you and Ayata Inc. agree that any judicial proceeding (other than small
              claims actions) will be brought in the state or federal courts.
            </p>
          </p>
        </div>

        <div className="form-group " style={{ padding: '0px 0px 40px 0px' }}>
          <label className="mb-0 d-block">General Legal Terms</label>
          <p style={{ color: 'var(--gray)' }}>
            Sometimes when you use the Services, you may (as a result of, or through your use of the Services) use a
            service or download a piece of software, or media, or purchase goods, which are provided by another person
            or company. Your use of these other services, software, or goods may be subject to separate terms between
            you and the company or person concerned. In the event the Terms do not affect your legal relationship with
            these other companies or individuals.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You and Ayata Inc. agree that the Terms constitute the complete and exclusive legal agreement between you
            and Ayata Inc. and govern your use of the Services (but excluding any services which Ayata Inc. may provide
            to you under a separate written agreement), and completely supersede and cancel any prior written and oral
            agreements, communications and other understandings between you and Ayata Inc. in relation to the Services
            and the subject matter of the Terms.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You will be responsible for paying, withholding, filing, and reporting all taxes, duties, and other
            governmental assessments associated with your activity in connection with the Services, provided that Ayata
            Inc. may, in its sole discretion, do any of the foregoing on your behalf or for itself as it sees fit.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You hereby acknowledge and agree that you are not an employee, agent, partner, or joint venture of Ayata
            Inc., and you do not have any authority of any kind to bind Ayata Inc. in any respect whatsoever.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You agree that Ayata Inc. may provide you with notices, including those regarding changes to the Terms, by
            email, regular mail, or postings on the Services. You agree that if you or Ayata Inc. do not exercise or
            enforce any legal right or remedy which is contained in the Terms (or which you or Ayata Inc. have the
            benefit of under any applicable law), this will not be taken to be a formal waiver of you or Ayata Inc.'s
            rights and that those rights or remedies will still be available to you or Ayata Inc..
          </p>
          <p style={{ color: 'var(--gray)' }}>
            If any court of law, having the jurisdiction to decide on this matter, rules that any provision of these
            Terms is invalid, then that provision will be removed to the minimum extent necessary from the Terms without
            affecting the rest of the Terms. The remaining provisions of the Terms will continue to be in full force and
            effect and enforceable.
          </p>
          <p style={{ color: 'var(--gray)' }}>
            You may not assign, delegate or transfer these Terms or your rights or obligations hereunder, or your
            Services account, in any way (by operation of law or otherwise) without Ayata Inc.ís prior written consInc.
            We may transfer, assign, or delegate these Terms and our rights and obligations without consInc. These Terms
            are governed by and will be construed under the Arbitration Act 1999 A.D. without regard to the conflicts of
            laws provisions thereof.
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;
